import { render, staticRenderFns } from "./IosDownRecord.vue?vue&type=template&id=d35296fa&"
import script from "./IosDownRecord.vue?vue&type=script&lang=js&"
export * from "./IosDownRecord.vue?vue&type=script&lang=js&"
import style0 from "./IosDownRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports